import React, { useState, useEffect } from "react";
import CustomerProgress from "../../../components/progressBar/CustomerProgress";
import { X } from "lucide-react";
import Loading from "../../../shared/Loading";

const ThirdModal = ({
  id_R,
  closePhoneModal,
  phoneModalOpen,
  openEmailModal,
  phoneNumber,
  openIDModal,
  setPhoneNumber,
  handleRegisterCustomer,
  loading,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [phoneError, setPhoneError] = useState("");

  const validatePhoneNumber = (number) => {
    if (!number) {
      setPhoneError("");
      return false;
    }

    if (number.startsWith("0") && number.length !== 10) {
      setPhoneError("Phone number starting with 0 must be 10 digits");
      return false;
    }

    if (number.startsWith("254") && number.length !== 12) {
      setPhoneError("Phone number starting with 254 must be 12 digits");
      return false;
    }

    if (!number.startsWith("0") && !number.startsWith("254")) {
      setPhoneError("Phone number must start with 0 or 254");
      return false;
    }

    setPhoneError("");
    return true;
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");

    if (value.startsWith("254")) {
      value = value.slice(0, 12);
    } else if (value.startsWith("0")) {
      value = value.slice(0, 10);
    }

    setPhoneNumber(value);

    if (value.length > 0) {
      validatePhoneNumber(value);
    } else {
      setPhoneError("");
    }
  };

  useEffect(() => {
    const isPhoneValid = validatePhoneNumber(phoneNumber);
    setIsButtonDisabled(!isPhoneValid);
  }, [phoneNumber]);

  const handleBackButtonClick = () => {
    // Close the current modal
    closePhoneModal();

    // Open the next modal
    openEmailModal();
  };

  return (
    <>
      <div
        onClick={closePhoneModal}
        id={id_R}
        className={`${
          phoneModalOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="relative flex rounded-[10px] h-[550px] w-[1080px] bg-white shadow"
        >
          <div
            onClick={closePhoneModal}
            className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
          >
            <X color="#ffffff" />
          </div>
          <div className="flex w-full">
            <div className=" w-[30%] rounded-[10px] bg-[#F5F6F7]">
              <div className="pt-4 px-2 rounded-t">
                <p className="text-[20px] font-bold text-[#000] ml-5">
                  Add Member
                </p>
              </div>
              <div className="mt-[32px] px-6">
                <CustomerProgress step={2} />
              </div>
            </div>
            <div className="w-[70%] mx-[10px] flex flex-col justify-between">
              <div className="h-[85%] w-[95%]">
                <div className="mt-5  mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Enter and verify Member phone number
                  </p>
                  <div className="text-[#000] mt-[10px] text-[15px] font-normal">
                    <p className="w-[99%]">
                      Kindly share Member’s primary phone number for
                      verification.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col justify-center mt-[50px]">
                  <label
                    htmlFor="phoneNumberInput"
                    className="mb-1 text-md font-medium text-[#000]"
                  >
                    Phone number
                  </label>
                  <div className="flex gap-5">
                    <input
                      type="text"
                      id="phoneNumberInput"
                      name="mobileno"
                      placeholder="Enter your phone number"
                      value={phoneNumber}
                      onChange={handlePhoneChange}
                      className={`w-full h-10 px-4 border border-[1px] ${
                        phoneError ? "border-red-500" : "border-[#000]"
                      }`}
                    />
                  </div>
                  {phoneError && (
                    <p className="text-red-500 text-sm mt-1">{phoneError}</p>
                  )}
                </div>
              </div>
              <div className="flex h-[15%] w-[95%] items-center justify-between">
                <button
                  onClick={handleBackButtonClick}
                  data-modal-toggle={id_R}
                  type="button"
                  className="text-[#000] bg-[#7FB8EB] hover:bg-[#7FB8EB] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                >
                  Back
                </button>

                <button
                  onClick={handleRegisterCustomer}
                  type="button"
                  className={`text-white flex items-center justify-center gap-[5px] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center ${
                    isButtonDisabled
                      ? "bg-[#D9D9D9]"
                      : "bg-[#074073] hover:bg-[#074073]"
                  }`}
                  disabled={isButtonDisabled}
                >
                  {loading && <Loading />}
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThirdModal;
